import { t } from 'commons/libs/i18n'
import {
  type HeadItemType,
  ITEMS_PER_PAGE,
  type PaginationParams,
  Table,
  Pagination as TablePagination,
} from 'components'
import type { LeadTimesData } from 'services/leadTimes'

import * as S from './styles'

interface LeadTimesTableProps {
  data: LeadTimesData[]
  pagination: PaginationParams
  setCurrentPage: (page: number) => Promise<void>
  disabled?: boolean
}

export const LeadTimesTable: React.FC<LeadTimesTableProps> = ({
  pagination,
  data,
  setCurrentPage,
  disabled = false,
}) => {
  if (!data) {
    return null
  }

  const headDataLeadTimes: HeadItemType[] = [
    { columnName: 'material', label: t('common.material') },
    { columnName: 'description', label: t('common.description') },
    { columnName: 'technology', label: t('common.technology') },
    { columnName: 'keyAccountsTime', label: 'Key Acc.' },
    { columnName: 'leadTimeAesp', label: 'AESP' },
    { columnName: 'leadTimeDtc', label: 'DTC' },
    { columnName: 'leadTime', label: t('common.standard') },
  ]

  const normalizeLeadTime = (value: number | string | null) => {
    if (typeof value === 'number' && value > 0) {
      return `${value} ${t('common.day', { count: value })}`
    }

    return '-'
  }

  const renderBody = () => {
    return data.map((item) => {
      const key = `${item.material}-${item.description}-${item.technology}-${item.leadTime}`

      return {
        content: [
          <span key={`Material-${key}`}>{item.material}</span>,
          <span key={`Description-${key}`}>{item.description}</span>,
          <span key={`Technology-${key}`}>{item.technology}</span>,
          <span key={`KeyAccountsTime-${key}`}>{normalizeLeadTime(item.keyAccountsTime)}</span>,
          <span key={`LeadTimeAesp-${key}`}>{normalizeLeadTime(item.leadTimeAesp)}</span>,
          <span key={`LeadTimeDtc-${key}`}>{normalizeLeadTime(item.leadTimeDtc)}</span>,
          <span key={`LeadTime-${key}`}>{normalizeLeadTime(item.leadTime)}</span>,
        ],
        id: `id-${key}`,
      }
    })
  }

  const headData = headDataLeadTimes

  return (
    <S.Container>
      <Table bodyData={renderBody()} fixedHead headData={headData} rowHeight={40} />
      <S.Divider />
      <TablePagination
        currentPage={pagination?.currentPage}
        disabled={disabled}
        itemsPerPage={ITEMS_PER_PAGE}
        numberOfItems={pagination?.totalItems}
        setCurrentPage={setCurrentPage}
      />
    </S.Container>
  )
}
